/**
 * Avatar initials (QA 2026-10-16): from the full name when there is one ("Alex Hormozi" → "AH", "Priya" → "P"),
 * else the first letter of the handle or email. Letters only (emoji and symbols in display names are skipped).
 */
export function initials(fullName: string | null | undefined, fallback?: string | null): string {
  const words = (fullName ?? '').split(/\s+/).map((w) => w.match(/\p{L}|\p{N}/u)?.[0] ?? '').filter(Boolean);
  if (words.length) return (words.length > 1 ? words[0]! + words[words.length - 1]! : words[0]!).toUpperCase();
  const f = (fallback ?? '').replace(/^@/, '').match(/\p{L}|\p{N}/u)?.[0];
  return (f ?? '?').toUpperCase();
}
